/*
   Theme Selector
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import '../../css/JourneySelector.css'
import { fetchPDFURLIfNeeded, printPDF } from '../../actions/journey-actions'
import { 
   personalizedName, 
   pdfURL, 
   pdfURLIsFetching, 
   pdfURLError,
   pdfPrintingError,
   pdfIsPrinting,
   selectedJourneyId,
   selectedArtworkIds,
   kioskMode
    } from '../../selectors/journeyState-selectors'
import { resetToHome, setJourneyNavStep, receivePDF } from '../../actions/journey-actions'
import ArtSummary from './ArtSummary'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';

import printButton from '../../assets/btn_print.png'
import createAnother from '../../assets/btn_createAnother.png'

class JourneyPrint extends React.Component {
   constructor(props) {
      super(props)
      this.state = { selectedJourney: null }
   }

   handleClick(journeyId) {}
   handleStartOver(galleryId) {}
   
   render() {
      const { resetToHome, galleryId, personalizedName, 
         setJourneyNavStep, fetchPDFURLIfNeeded, pdfURL, receivePDF,
         pdfURLIsFetching, pdfURLError, journeyId, pdfIsPrinting,
         selectedArtworkIds, printPDF, kioskMode, pdfPrintingError } = this.props
      return   (
         <div className={'journey-content-container journey-print-container'}>
            <div className={'bordered-container title'}>
               <div className={'large-3 border'}>
                  Thanks <strong>{personalizedName}</strong>!<br/>
                  Your Journey is ready!
               </div>
            </div>
            <ArtSummary galleryId={galleryId} />
            {!pdfURL && 
               <Hammer 
               onTap={() => fetchPDFURLIfNeeded(galleryId, journeyId, selectedArtworkIds, personalizedName)} 
               options={tapOptions} >
               <button className={'print-button create-your-guide large-1'}>CREATE YOUR GUIDE</button>
            </Hammer>
            }
            <div>
               {pdfURLIsFetching && 
                  <div className='large-1'>{'Generating your guide...'}</div>
               }
               {pdfURLError && 
                  <div className='large-1'>{'There was an error downloading the PDF. Please see an administrator.'}</div>
               }
               {pdfIsPrinting && 
                  <div className='large-1'>{'Sending To Printer...'}</div>
               }
               {pdfPrintingError && 
                  <div className='large-1'>{'There was an error printing the PDF. Please see an administrator.'}</div>
               }
               {pdfURL && kioskMode &&
               <Hammer 
                  onTap={() => printPDF(pdfURL, galleryId)}
                  options={tapOptions} >
                  <button className={'print-button send-to-printer large-1'}>SEND TO PRINTER</button>
               </Hammer>
               }
               {pdfURL && !kioskMode &&
               <Hammer 
                  onTap={() => window.open(pdfURL)}
                  options={tapOptions} >
                  <button className={'print-button view-my-arthunt large-1'}>VIEW MY ART HUNT (PDF)</button>
               </Hammer>
               }
            </div>
            <div className={'bottom-button-group'}>
               <Hammer onTap={() => resetToHome(galleryId)} options={tapOptions} >
                  <img src={createAnother} alt={'Create Another'} />
               </Hammer>
            </div>
         </div>
      )
   }
}

const mapStateToProps = (state, ownProps) => {
   return {
      personalizedName: personalizedName(state, ownProps),
      pdfURL: pdfURL(state, ownProps),
      pdfURLIsFetching: pdfURLIsFetching(state, ownProps),
      pdfURLError: pdfURLError(state, ownProps),
      pdfPrintingError: pdfPrintingError(state, ownProps),
      journeyId: selectedJourneyId(state, ownProps),
      selectedArtworkIds: selectedArtworkIds(state, ownProps),
      kioskMode: kioskMode(state, ownProps),
      pdfIsPrinting: pdfIsPrinting(state, ownProps),
     ...ownProps
   }
}
const mapDispatchToProps = dispatch => bindActionCreators({
   resetToHome,
   setJourneyNavStep,
   fetchPDFURLIfNeeded,
   printPDF,
   receivePDF
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyPrint)


// WEBPACK FOOTER //
// ./src/components/FinalizeJourney/JourneyPrint.js